import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3001';

/**
 * DoorlyDesk read-only Reg B joint-credit-intent status. View only — there is
 * deliberately NO control here to set or backdate an affirmation (admins must
 * never author one). Renders nothing when there's no co-borrower pairing.
 */
export default function JointIntentAdminCard({ borrowerId, token }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!borrowerId || !token) return;
    axios.get(`${API}/api/admin/borrowers/${borrowerId}/joint-intent`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setData(r.data))
      .catch(() => setData({ has_connection: false }));
  }, [borrowerId, token]);

  if (!data || !data.has_connection) return null;

  const fmt = (t) => (t ? new Date(t).toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : null);
  const Pill = ({ ok }) => (
    <span style={{ fontSize: 11, fontWeight: 700, borderRadius: 9999, padding: '2px 8px',
      background: ok ? '#dcfce7' : '#fef3c7', color: ok ? '#166534' : '#92400e' }}>
      {ok ? 'Affirmed' : 'Pending'}
    </span>
  );
  const Row = ({ label, ok, at, method }) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '6px 0', borderBottom: '1px solid #f3f4f6' }}>
      <span style={{ fontSize: 12, color: '#374151' }}>{label}</span>
      <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {at && <span style={{ fontSize: 11, color: '#6b7280' }}>{fmt(at)}{method ? ` · ${method}` : ''}</span>}
        <Pill ok={ok} />
      </span>
    </div>
  );

  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, padding: '14px 16px', marginBottom: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#111827' }}>Joint-Credit Intent (Reg B)</div>
        <Pill ok={data.both_affirmed} />
      </div>
      <Row label="Primary applicant" ok={data.primary_affirmed} at={data.primary_affirmed_at} method={data.primary_method} />
      <Row label="Co-applicant" ok={data.coborrower_affirmed} at={data.coborrower_affirmed_at} method={data.coborrower_method} />
      <div style={{ fontSize: 10, color: '#9ca3af', marginTop: 8 }}>
        Co-borrower credit pull is gated until both are affirmed. View only — affirmations are applicant-authored and cannot be set here.
        {data.disclosure_version ? ` · disclosure ${data.disclosure_version}` : ''}
      </div>
    </div>
  );
}
